import React from "react";

export default function PrivacyPolicy() {
    return (
        <div style={{ padding: "10%", paddingTop: "10px" }}>
            <h1>Next Stock Privacy Policy</h1>

            <p>
                <strong>Last Updated:</strong> March 2026
            </p>

            <p>
                Otaner Tech Inc. ("we", "us", or "our") operates the Next Stock
                website, web application, and ChatGPT app integration
                (collectively, the "Service").
            </p>

            <p>
                This Privacy Policy explains how we collect, use, and protect
                your personal information when you use the Service.
            </p>

            <h2>1. Information We Collect</h2>

            <h3>Account Information</h3>

            <p>
                If you create a Next Stock account, we may collect:
            </p>

            <ul>
                <li>Email address</li>
                <li>
                    Account information provided through third-party login
                    providers such as Google, Facebook, or Apple
                </li>
            </ul>

            <p>
                We do not intentionally collect or permanently store the
                content of your ChatGPT prompts beyond what is required to
                generate a response.
            </p>

            <p>
                We do not intentionally collect sensitive personal information,
                including government identifiers, health information, or
                financial account numbers.
            </p>

            <h2>2. How We Use Your Information</h2>

            <ul>
                <li>Provide and maintain the Service</li>
                <li>Generate stock analytics and investment insights</li>
                <li>Authenticate your account</li>
                <li>Process subscriptions</li>
                <li>Communicate service updates</li>
                <li>Improve platform performance and functionality</li>
            </ul>

            <p>
                We do not sell personal information to third parties for
                marketing or advertising purposes.
            </p>

            <h2>3. ChatGPT and Third-Party Services</h2>

            <p>
                When you use the Next Stock ChatGPT app, your prompts and
                interactions are processed by OpenAI as part of the ChatGPT
                platform.
            </p>

            <p>
                OpenAI handles this information under its own terms and privacy
                policies.
            </p>

            <p>
                We may also use trusted service providers to host our
                infrastructure, process subscription payments, and send email
                communications.
            </p>

            <h2>4. Payment Information</h2>

            <p>
                Subscription payments are processed by third-party payment
                processors such as Stripe.
            </p>

            <p>
                We do not store your full credit card information on our
                servers.
            </p>

            <h2>5. Data Security</h2>

            <p>
                We implement reasonable technical and organizational measures
                designed to protect personal information.
            </p>

            <p>
                However, no method of transmission or storage is completely
                secure and we cannot guarantee absolute security.
            </p>

            <h2>6. Retention of Information</h2>

            <p>
                We retain account information only for as long as necessary to
                provide the Service, comply with legal obligations, resolve
                disputes, and enforce agreements.
            </p>

            <h2>7. International Data Transfers</h2>

            <p>
                Your information may be transferred to and processed in Canada,
                the United States, or other jurisdictions where our service
                providers operate.
            </p>

            <h2>8. Children's Privacy</h2>

            <p>
                The Service is not intended for children under the age of 13.
            </p>

            <p>
                We do not knowingly collect personal information from children.
            </p>

            <h2>9. Your Rights and Choices</h2>

            <p>
                Depending on your jurisdiction, you may have the right to:
            </p>

            <ul>
                <li>Access your personal information</li>
                <li>Correct inaccurate information</li>
                <li>Request deletion of personal information</li>
                <li>Withdraw consent where applicable</li>
            </ul>

            <p>
                To exercise these rights, please contact us using the
                information below.
            </p>

            <h2>10. Compliance with Canadian Law</h2>

            <p>
                We comply with applicable Canadian privacy laws, including the
                Personal Information Protection and Electronic Documents Act
                (PIPEDA).
            </p>

            <h2>11. Facebook Data Deletion Instructions</h2>

            <ol>
                <li>
                    Visit Facebook App Settings:
                    {" "}
                    <a
                        href="https://www.facebook.com/settings?tab=applications"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Facebook App Settings
                    </a>
                </li>
                <li>Locate Next Stock in your connected apps.</li>
                <li>Remove the application.</li>
                <li>
                    Contact us if you would also like any remaining account data
                    removed.
                </li>
            </ol>

            <h2>12. Changes to This Privacy Policy</h2>

            <p>
                We may update this Privacy Policy periodically. Updates become
                effective when published on this page.
            </p>

            <h2>13. Contact Us</h2>

            <p>
                Email:
                {" "}
                <a href="mailto:contact@otanertech.com">
                    contact@otanertech.com
                </a>
            </p>
        </div>
    );
}